import { render } from "./CustomerDashboard.vue?vue&type=template&id=c3169a94&scoped=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"

import "./CustomerDashboard.vue?vue&type=style&index=0&id=c3169a94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3169a94"]])

export default __exports__